// extracted by mini-css-extract-plugin
export var button = "arrow-button-module--button--1WElO";
export var icon = "arrow-button-module--icon--1pnjG";
export var showDisable = "arrow-button-module--show-disable--k+R2M";